<template>
  <b-modal class="modal-sm" id="ModalAcceptBatch" ref="acceptBatch-modal" :title="acceptBatchModal.modalData.title" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" @show="fetchAdditionalInfo" @hide="resetModal('main'); resetForm()">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fas', 'marker']" size="1x" class="mr-2"/> {{ acceptBatchModal.modalData.title }}</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default" slot-scope="{ close }">
      <loading
          id="widget-loading-spinner"
          class="align-items-center model-loader"
          :color="'#047bf8'"
          :loader="'spinner'"
          :active="modalIsBusy"
          :is-full-page="false"></loading>
      <div v-if="!modalIsBusy">
        <div class="col-12">
          <h5 class="py-2">{{ t('acceptAllModalHeading','acceptAllModalHeading') }}</h5>
        </div>
        <b-form-group>
          <div class="col-12">
            <b-form-checkbox-group id="delivery-options" v-model="deliveryOptions" name="flavour-2" @change="deliveryOptionsChange">
              <b-form-checkbox value="electronicsOnly">{{t('labelElectronicsOnly','labelElectronicsOnly')}}</b-form-checkbox>
              <b-form-checkbox :disabled="onlineDisable" value="sendData">{{t('labelSendData','labelSendData')}}</b-form-checkbox>
              <b-form-checkbox :disabled="onlineDisable" value="sendEmail">{{t('labelSendEmail','labelSendEmail')}}</b-form-checkbox>
              <b-form-checkbox :disabled="onlineDisable" value="sendFax">{{t('labelSendFax','labelSendFax')}}</b-form-checkbox>
              <b-form-checkbox value="sendPost">{{t('labelSendPost','labelSendPost')}}</b-form-checkbox>
            </b-form-checkbox-group>
            <p v-if="displaySettings.batchTestMode != null" >{{t('warningTestBatchWontDeliver', 'warningTestBatchWontDeliver')}}</p>
          </div>
          <div class="col-12 mt-3">
            <div class="d-flex align-items-center">
              <label for="related-levels-dataxfer" class="d-inline col-10">{{t('labelRelatedLevelsDataxfer','labelRelatedLevelsDataxfer') }}</label>
              <input id="related-levels-dataxfer" v-model="relatedLevels.dataxfer_related_levels" class="d-inline form-control col-2" type="text">
            </div>
            <div class="d-flex align-items-center">
              <label for="related-levels-email" class="d-inline col-10">{{t('labelRelatedLevelsEmail','labelRelatedLevelsEmail') }}</label>
              <input id="related-levels-email" v-model="relatedLevels.email_related_levels" class="d-inline form-control col-2" type="text">
            </div>
            <div class="d-flex align-items-center">
              <label for="related-levels-fax" class="d-inline col-10">{{t('labelRelatedLevelsFax','labelRelatedLevelsFax') }}</label>
              <input id="related-levels-fax" v-model="relatedLevels.fax_related_levels" class="d-inline form-control col-2" type="text">
            </div>
            <div class="d-flex align-items-center">
              <label for="related-levels-post" class="d-inline col-10">{{t('labelRelatedLevelsPost','labelRelatedLevelsPost') }}</label>
              <input id="related-levels-post" v-model="relatedLevels.post_related_levels" class="d-inline form-control col-2" type="text">
            </div>
          </div>
        </b-form-group>
        <ResponseInfo v-if="getResponseInfo.responseName == 'approveDocumentsView'"></ResponseInfo>
      </div>
    </template>
    <template slot="modal-footer" slot-scope="{ cancel, close }">
        <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary" type="button" @click="cancel()">
          <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>{{ t('cancelAndCloseButtonText', 'cancelAndCloseButtonText')}}
        </button>
        <button aria-label="AcceptAllDocs" data-dismiss="modal" :disabled="modalIsBusy" class="btn btn-primary" type="button" @click="acceptAll()">
          <fontAwesomeIcon :icon="['fa', 'thumbs-up']" class="text-light mr-2"/> {{ t('acceptProofButtonText', 'acceptProofButtonText')}}
        </button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import Loading from 'vue-loading-overlay'
import ResponseInfo from '@/components/ResponseInfo.vue'

export default {
  name: 'ModalAcceptBatch',
  //this component inherits from the Search.vue component
  inject: [
    'resetModal',
    'displaySettings'
  ],
  data () {
    return {
      deliveryOptions: [],
      relatedLevels: {
        dataxfer_related_levels: 0,
        email_related_levels: 0,
        fax_related_levels: 0,
        post_related_levels: 0,
      },
      acceptBatchModal: {},
      buttonIsBusy: false,
      modalIsBusy: false,
      onlineDisable: false
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo'])
  },
  methods:{
    fetchAdditionalInfo(entries) {
      //clear previous response
      this.$store.dispatch('alertClearResponse')
      this.modalIsBusy = true
      this.loaderBusy = true
      //default settings for delivery checkboxes
      //get data from back
      this.$store.dispatch('documentToolsStore/getBatchAcceptInfo',{
        batchId: this.$route.query.batch
      }).then(() => {
        let relatedLevels = this.$store.getters['documentToolsStore/getRelatedLevels']
        let deliveryOptions = this.$store.getters['documentToolsStore/getDeliveryOptions']

        if (relatedLevels && deliveryOptions) {
          for (const [key, value] of Object.entries(deliveryOptions)) {
           if (value == 1 || value == true) {
             this.deliveryOptions.push(key)
           }
          }

          Object.entries(relatedLevels).forEach(([key, value]) => {
            this.relatedLevels[key] = value
          })
        } else {
          //default settings
          this.deliveryOptions = ['sendEmail', 'sendFax', 'sendPost']
          Object.entries(this.relatedLevels).forEach((key) => {
            this.relatedLevels[key] = 0
          })
        }
        this.modalIsBusy = false
        this.loaderBusy = false
      })
    },
    deliveryOptionsChange(newVal) {
      if (Array.isArray(newVal) && newVal.includes('electronicsOnly')) {
        this.onlineDisable = true
      } else {
        this.onlineDisable = false
      }
    },
    acceptAll() {
      this.buttonIsBusy = true
      this.$store.dispatch('documentToolsStore/handleDocumentTool',{
        action: 'acceptAllDocuments',
        documents: this.acceptBatchModal.docuData,
        deliveryOptions: this.deliveryOptions,
        relatedLevels: this.relatedLevels,
        batchId: this.$route.query.batch
      })
      .then(() => {
        this.buttonIsBusy = false
        let responseStatus = this.getResponseInfo.status
        if(responseStatus != 'error'){
          this.$refs['acceptBatch-modal'].hide()
          this.$router.push({name: "manage_batches", params: { response: 'approveSuccess' }})
        }
      })
    },
    resetForm() {
      //default settings
      this.deliveryOptions = []
      Object.entries(this.relatedLevels).forEach((key) => {
        this.relatedLevels[key] = 0
      })
      this.onlineDisable = false
    }
  },
  created() {
    this.acceptBatchModal = this.$attrs.modal
  },
  filters:{
  },
  components:{
    ResponseInfo,
    Loading,
  }
}
</script>

<style scoped>
.button-h {
  max-height: 30px;
}
.modal-open #modalAddressBook___BV_modal_outer_ >>> .modal-content{
  min-width: 750px !important;
  max-width: auto !important;
  width: auto !important;
}
.modal-open #modalAddressBook___BV_modal_outer_ >>> .modal-content .modal-body{
  max-height: 450px;
  overflow-y: scroll;
}

.model-loader {
  height: 100% !important;
}
/*
.modal-open #modalAddressBook___BV_modal_outer_ >>> #addressbook-customers-table tbody tr{
  background-color: pink !important;
}
*/
</style>
